{
	"accountsPayable": "Cuentas a pagar",
	"accountsReceivable": "Cuentas a recibir",
	"costCenter": "Centro de coste",
	"planAccounts": "Plan de cuentas",
	"providers": "Gestión de socios",
	"receiptAccounts": "Recibos de cuentas",
	"reports": "Reportes",
	"cashflow": "Flujo de caja",
	"finExManagerialReport": "DRE",
	"noticeIsFreeModule": "Módulo gratuito hasta",
	"conciliation": "Conciliación a través de OFX",
	"bankAccounts": "Comptes bancaires",
	"eventConference": "Conferencia de eventos"
}
